import type { ModelAssignment } from '@/types/api/accounts'
import type { ModelConstraint } from '@/types/api/constraints'

type Customizations = ModelAssignment['customizations']

// Each rule's id is set to its key, whatever the saved body holds.
export function fiConstraintsFromCustomizations(
  customizations: Customizations | undefined,
): Record<string, ModelConstraint | null> {
  return Object.fromEntries(
    Object.entries(customizations?.fixed_income ?? {}).map(
      ([id, constraint]) => [
        id,
        constraint === null ? null : { ...constraint, id },
      ],
    ),
  )
}

export function buildCustomizations(
  fiConstraints: Record<string, ModelConstraint | null>,
): Customizations {
  if (Object.keys(fiConstraints).length === 0) {
    return {}
  }
  return { fixed_income: fiConstraints }
}
